import {useCallback} from "react";

import {WalletContextReducerAction} from "../../../wallet/util/context/WalletContext.types";
import {
  fetchAccounts,
  getSelectedAccountAddressFromWebStorage,
  mapAccountsToAppStateAccounts,
  resetWalletItemsOnWebStorage
} from "../../../wallet/util/walletUtils";
import {WalletType} from "../../../wallet/util/walletTypes";

function useWalletConnectUpdateHandler(
  dispatch: React.Dispatch<WalletContextReducerAction>
) {
  return useCallback(
    async (accountAddresses: string[]) => {
      try {
        const storedAddress = getSelectedAccountAddressFromWebStorage();

        if (accountAddresses?.length && storedAddress) {
          const accounts = await fetchAccounts(accountAddresses);
          const finalAccountsData = await mapAccountsToAppStateAccounts(accounts);
          const selectedAccountData = finalAccountsData.find(
            (accountData) => accountData.detail.address === storedAddress
          );

          if (selectedAccountData) {
            dispatch({
              type: "SET_WALLET_AND_ACCOUNTS",
              accounts: finalAccountsData,
              walletType: WalletType.WalletConnect,
              selectedAccount: selectedAccountData
            });
          } else {
            await resetWalletItemsOnWebStorage();
            dispatch({
              type: "DISCONNECT"
            });
          }
        }
      } catch (error) {
        console.error(error);
      }
    },
    [dispatch]
  );
}

export default useWalletConnectUpdateHandler;
